import MicroplateWellSelect from './MicroplateWellSelect'

export default MicroplateWellSelect
